module.exports = __webpack_public_path__ + "img/delivery (1).52300f4c.png";